/* eslint-disable */
/**
 * @author Leonel Martinez
 * @description `interchangeService`
 * @exports interchangeService
 */
import { API } from "@/services";
import { http } from "@/utils";

export const interchangeService = {
  search: (wildcard)=> 
     http.get(`${API.INTERCHANGE}?q=${wildcard}`).catch(e => e.response)
};

/**
 * @description Looks for possible wildcard results
 * @param {string} wildcard 
 * @returns {Array} Items that match with the wildcard search
 */
// function search(wildcard) {
//   return http
//     .get(API.INTERCHANGE + '?q=' + wildcard)
//     .catch(e => e.response);
// }